var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_246_26000)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_26000)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1807 25.8966H8.65517C7.74105 25.8966 7 25.1555 7 24.2414V12.6552C7 11.741 7.74105 11 8.65517 11H27.6897C28.6038 11 29.3448 11.741 29.3448 12.6552V20.7324L24.1807 25.8966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3448 13.4828H7V16.7931H29.3448V13.4828Z",
    fill: "url(#paint1_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89653 21.3448H9.06894C8.84041 21.3448 8.65515 21.1595 8.65515 20.931C8.65515 20.7025 8.84041 20.5172 9.06894 20.5172H9.89653C10.1251 20.5172 10.3103 20.7025 10.3103 20.931C10.3103 21.1595 10.1251 21.3448 9.89653 21.3448Z",
    fill: "url(#paint2_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3793 21.3448H11.5517C11.3232 21.3448 11.1379 21.1595 11.1379 20.931C11.1379 20.7025 11.3232 20.5172 11.5517 20.5172H12.3793C12.6079 20.5172 12.7931 20.7025 12.7931 20.931C12.7931 21.1595 12.6079 21.3448 12.3793 21.3448Z",
    fill: "url(#paint3_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8621 21.3448H14.0345C13.806 21.3448 13.6207 21.1595 13.6207 20.931C13.6207 20.7025 13.806 20.5172 14.0345 20.5172H14.8621C15.0906 20.5172 15.2759 20.7025 15.2759 20.931C15.2759 21.1595 15.0906 21.3448 14.8621 21.3448Z",
    fill: "url(#paint4_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3448 21.3448H16.5172C16.2887 21.3448 16.1034 21.1595 16.1034 20.931C16.1034 20.7025 16.2887 20.5172 16.5172 20.5172H17.3448C17.5733 20.5172 17.7586 20.7025 17.7586 20.931C17.7586 21.1595 17.5733 21.3448 17.3448 21.3448Z",
    fill: "url(#paint5_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 23.8276C31.0015 25.5376 29.839 27.0291 28.1804 27.4454C26.5219 27.8617 24.7928 27.096 23.9865 25.5881C23.1801 24.0801 23.5033 22.2169 24.7704 21.0687C26.0376 19.9205 27.9235 19.7818 29.3449 20.7324C30.3788 21.4232 30.9997 22.5843 31.0001 23.8276Z",
    fill: "url(#paint6_linear_246_26000)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9312 23.4138H27.6898V22.1724C27.6898 21.9439 27.5045 21.7586 27.276 21.7586C27.0475 21.7586 26.8622 21.9439 26.8622 22.1724V23.4138H25.6208C25.3923 23.4138 25.207 23.599 25.207 23.8276C25.207 24.0561 25.3923 24.2414 25.6208 24.2414H26.8622V25.4827C26.8622 25.7113 27.0475 25.8965 27.276 25.8965C27.5045 25.8965 27.6898 25.7113 27.6898 25.4827V24.2414H28.9312C29.1597 24.2414 29.345 24.0561 29.345 23.8276C29.345 23.599 29.1597 23.4138 28.9312 23.4138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_26000",
    x1: 0,
    y1: 0,
    x2: 42.4417,
    y2: 25.1135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_26000",
    x1: 7,
    y1: 13.4828,
    x2: 9.09799,
    y2: 21.8623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_246_26000",
    x1: 8.65515,
    y1: 20.5172,
    x2: 9.75265,
    y2: 21.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_246_26000",
    x1: 11.1379,
    y1: 20.5172,
    x2: 12.2354,
    y2: 21.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_246_26000",
    x1: 13.6207,
    y1: 20.5172,
    x2: 14.7182,
    y2: 21.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_246_26000",
    x1: 16.1034,
    y1: 20.5172,
    x2: 17.2009,
    y2: 21.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_246_26000",
    x1: 23.5459,
    y1: 20.1035,
    x2: 32.3341,
    y2: 25.3034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_26000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.5517,
    fill: "white",
    transform: "translate(7 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.43ba058c.svg";
export { ForwardRef as ReactComponent };